import React, { useMemo } from 'react';
import { Platform } from 'react-native';
import { Image } from 'expo-image';

/** Classic arrow cursor — white fill, black outline (Assignments Builder tile badge). */
export default function CursorPointerIcon({ size = 18, style }) {
  const uri = useMemo(() => {
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M5 2 L5 18.5 L9.25 14.25 L12.75 21.5 L14.75 20.5 L11.25 13.25 L17.5 13.25 Z"
        fill="#FFFFFF" stroke="#000000" stroke-width="1.4" stroke-linejoin="round"/>
    </svg>`;
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
  }, []);

  return (
    <Image
      source={{ uri }}
      style={[{ width: size, height: size }, style]}
      contentFit="contain"
      {...(Platform.OS !== 'web' ? { accessibilityIgnoresInvertColors: true } : {})}
    />
  );
}
